"use strict";

import classNames from "classnames";
import React, { Component, PropTypes } from "react";
import InputComponentBase from ".\\InputComponentBase";

/******************************************************************************
** TextInput
*/

export default class TextInput extends InputComponentBase {

	constructor (props) {
		super(props);
	}

	renderEditor(placeholderText) {
		return (
				<input ref="input" type="text" className="input-field__input"
						id={this.state.clientId} name={this.state.inputName} placeholder={placeholderText}
						defaultValue={this.props.defaultValue}
						onFocus={this._onFocus} onBlur={this._onBlur}
						onChange={this._onChange} onInput={this._onInput} onSubmit={this._onSubmit}
						/>
			);
	}
}



/** WEBPACK FOOTER **
 ** ./forms/TextInput.jsx
 **/